checkoutEnabled